<template>
  <div id="safe-appointment">
    <div v-if="safeAppointment != null" class="locator__place-extended-download">
      <h3 class="locator__place-extended-title">
        <a :data-tooltip="tooltipText"
           class="btn  has-tooltip-bottom"
           @click="onAppointmentClick(); isActive = !isActive"> {{
            buttonName() ? safeAppointment.button : $t('safe_appointment')
          }}</a></h3>
    </div>
    <modal :content="'asd'" :isActive="isActive" @update-modal="update">
      <safeAppointmentForm :institutionId="institutionId" :institutionName="institutionName" :city="city" @form-result="formResult"></safeAppointmentForm>
    </modal>
  </div>
</template>

<script>
import modal from "./modal";
import safeAppointmentForm from './forms/safe-appointment-form'
import Swal from 'sweetalert2'

export default {
  name: "safe-appointment",
  props: ['safeAppointment', 'institutionId', 'institutionName', 'city'],
  components: {
    modal,
    safeAppointmentForm
  },
  data() {
    return {
      isActive: false,
      tooltipText: ''
    };
  },
  mounted() {
    if (this.safeAppointment != null) {
      this.tooltipText = this.safeAppointment.tooltip;
    }
  },
  methods: {
    buttonName() {
      return this.safeAppointment !== null && this.safeAppointment.hasOwnProperty('button');
    },
    update(state) {
      this.isActive = state;
    },
    onAppointmentClick() {
      parent.dataLayer.push({
        nazwamiasta: this.city,
        nazwasalonu: this.institutionName,
        event: "umow-wizyte-klik"
      });
    },
    formResult(state) {
      let icon = state ? 'success' : 'error';
      let message;
      let html;
      if (state) {
        if (this.$appLang.toLowerCase() == 'lt') {
          message = 'Forma išsiųsta<br />Gauti el. laišką<br />Pasirinkta optikos parduotuvė kuo greičiau su jumis susisieks ir patvirtins susitikimą.';
          html = "";
        } else {
          message = 'Formularz został wysłany<br />Odbierz swoją pocztę e-mail<br />Wybrany salon optyczny skontaktuje się z Tobą najszybciej jak tylko będzie to możliwe w celu potwierdzenia wizyty.';
          html = "";
        }
      } else {
        if (this.$appLang.toLowerCase() == 'lt') {
          message = 'Įvyko klaida, bandykite dar kartą';
          html = 'Kreipkitės į administratorių';
        } else {
          message = 'Wystąpił błąd, spróbuj ponownie';
          html = 'Skontaktuj się z administratorem';
        }
      }

      Swal.fire(
          message,
          html,
          icon
      );
      this.isActive = false
    }
  }

};
</script>

<style>
[data-tooltip]:hover:before,
[data-tooltip]:hover:after {
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.5);
  font-size: 13px;
  min-width: 220px;
  font-weight: bold;
  color: #FFF;
  margin-bottom: 12px;
  text-transform: uppercase;
  white-space: normal;
  padding: 30px;
}
</style>
